interface JSONToCSVConverterVM {
  json?: Array<Record<string, string>>;
  title: string;
}

export const JSONToCSVConverter = ({ json, title }: JSONToCSVConverterVM): void => {
  const jsonData = json || [];

  const [firstElement] = jsonData;

  if (!(jsonData.length > 0)) {
    return;
  }

  const arrDataKeys = Object.keys(firstElement);

  const arrData = Object.values(jsonData);

  // CSV string variable
  let CSV = '';

  // The row
  let firstLabelRow = '';

  //This loop will extract the label from 1st index of on array (labels)
  arrDataKeys.forEach((element) => {
    //Now convert each value to string and comma-seprated
    firstLabelRow += `${element},`;
  });

  firstLabelRow = firstLabelRow.slice(0, -1);

  //append Label row with line break
  CSV += `${firstLabelRow}\r\n`;

  //1st loop is to extract each row
  arrData.forEach((item) => {
    let valueRows = '';

    //2nd loop will extract each column and convert it in string comma-seprated
    Object.values(item).forEach((valueItem) => {
      valueRows += `"${valueItem}",`;
    });

    valueRows.slice(0, valueRows.length - 1);

    //add a line break after each row
    CSV += `${valueRows}\r\n`;
  });

  if (!CSV) {
    return;
  }

  //Generate a file name
  const fileName = title;

  //Initialize file format you want csv or xls
  const uri = `data:text/csv;charset=utf-8,${escape(CSV)}`;

  //this trick will generate a temp <a /> tag
  const link = document.createElement('a');
  link.href = uri;

  //set the visibility hidden so it will not effect on your web-layout
  link.style.visibility = 'hidden';
  link.download = `${fileName}.csv`;

  //this part will append the anchor tag and remove it after automatic click
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
